import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.access');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-access',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.access/view.scss */
:host {
  display: block;
}

.auth-shell {
  background-image: radial-gradient(circle at 15% 15%, rgba(251, 191, 36, 0.12), transparent 25rem), radial-gradient(circle at 85% 85%, rgba(59, 130, 246, 0.08), transparent 28rem);
}

.auth-label {
  display: block;
  margin-bottom: 0.45rem;
  color: #475569;
  font-size: 0.72rem;
  font-weight: 700;
}

.auth-input {
  display: block;
  width: 100%;
  border: 1px solid #cbd5e1;
  border-radius: 0.75rem;
  padding: 0.8rem 0.875rem;
  color: #0f172a;
  font-size: 0.875rem;
  outline: none;
  transition: border-color 0.15s, box-shadow 0.15s;
  min-height: 3rem;
  background: #fff;
}

.auth-input:focus {
  border-color: #f59e0b;
  box-shadow: 0 0 0 3px rgba(245, 158, 11, 0.13);
}

.auth-primary {
  display: flex;
  width: 100%;
  justify-content: center;
  border-radius: 0.75rem;
  background: #0f172a;
  padding: 0.85rem 1rem;
  color: white;
  font-size: 0.875rem;
  font-weight: 900;
  transition: background 0.15s, transform 0.15s;
}

.auth-primary:hover {
  background: #1e293b;
  transform: translateY(-1px);
}

.auth-primary:disabled {
  cursor: wait;
  opacity: 0.6;
  transform: none;
}

.auth-back {
  display: flex;
  min-height: 2.75rem;
  align-items: center;
  justify-content: center;
  margin: 1.25rem auto 0;
  color: #64748b;
  font-size: 0.72rem;
  font-weight: 700;
}

.auth-input:-webkit-autofill {
  -webkit-box-shadow: 0 0 0 1000px #fff inset;
  -webkit-text-fill-color: #0f172a;
}`],
})
export class PageAccessComponent implements OnInit {
    public view: string = 'login';
    public busy: boolean = false;

    public loginData: any = { email: '', password: '' };
    public registerData: any = { name: '', email: '', password: '', passwordConfirm: '' };
    public resetRequestData: any = { email: '' };

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        const check = await this.service.auth.check();
        if (check) location.href = '/dashboard';
    }

    public async switchView(view: string) {
        this.view = view;
        await this.service.render();
    }

    public async notify(message: string, status: string = 'error') {
        return await this.service.modal.show({
            title: '',
            message,
            cancel: false,
            actionBtn: status,
            action: '확인',
            status
        });
    }

    public async login() {
        if (!this.loginData.email || !this.loginData.password) {
            return await this.notify('아이디와 비밀번호를 입력해주세요.');
        }

        this.busy = true;
        const { code, data } = await wiz.call('login', this.loginData);
        this.busy = false;
        if (code === 200) {
            location.href = '/dashboard';
            return;
        }
        await this.notify(data.message || '로그인에 실패했습니다.');
    }

    public async register() {
        if (!this.registerData.name || !this.registerData.email || !this.registerData.password) {
            return await this.notify('필수 항목을 입력해주세요.');
        }
        if (this.registerData.password !== this.registerData.passwordConfirm) {
            return await this.notify('비밀번호가 일치하지 않습니다.');
        }

        this.busy = true;
        const { code, data } = await wiz.call('register', this.registerData);
        this.busy = false;
        if (code === 201) {
            location.href = '/dashboard';
            return;
        }
        await this.notify(data.message || '회원가입에 실패했습니다.');
    }

    public async requestReset() {
        if (!this.resetRequestData.email) {
            return await this.notify('이메일을 입력해주세요.');
        }

        this.busy = true;
        const { code, data } = await wiz.call('request_reset', this.resetRequestData);
        this.busy = false;
        if (code !== 200) {
            return await this.notify(data.message || '요청에 실패했습니다.');
        }
        await this.notify(data.message, 'success');
        this.loginData.email = this.resetRequestData.email;
        this.view = 'login';
        await this.service.render();
    }
}

export default PageAccessComponent;